import React, { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormSelect,
  CButton,
  CFormTextarea,
} from '@coreui/react';
import { fetchAuthSession  } from 'aws-amplify/auth';
import AWS from 'aws-sdk';

function Billing() {

  const DYNAMODB_TABLE_NAME = 'codeflex';
  const REGION ='us-east-1';

  const dynamodb = new AWS.DynamoDB.DocumentClient({
    region: REGION,
    credentials: new AWS.Credentials({
      accessKeyId: process.env.REACT_APP_ACCESSKEYID,
      secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY
    }),
  });

  useEffect(() => {
    (async () => {
      try {
        await fetchAuthSession().then(data => 
        {
          //console.log(data);
          setUser(data.tokens.accessToken.payload.sub);
          setEmail(data.tokens.idToken.payload.email);
          leerptoyectos(data.tokens.accessToken.payload.username);

        });

      } catch (err) {
        console.log(err);
      }

    })();	
	},[]);


  const [sub, setUser] = useState()
  const [base,SetDB] = useState();
  const [email,setEmail] = useState();

  async function leerptoyectos(sub) {
    const params = {
      TableName: DYNAMODB_TABLE_NAME, 
      Key: {
        token: sub,
      },
    };
  
    try {
      const data = await dynamodb.get(params).promise();
      if (data.Item) {
        let validado = data.Item.premium;
        SetDB(validado);
      } else {
        console.log('Usuario no encontrado.');
      }
    } catch (err) {
      console.error('Error al buscar usuario:', err);
    }
  }

  const [voz, setVoz] = useState('Lupe');
  const [mensaje, setMensaje] = useState('Hola! Mi nombre es Lupe. Puedo leer cualquier texto que introduzcas aquí.');
  const [audioPlayer, setAudioPlayer] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const [voz2, setVoz2] = useState('Lucia');
  const [mensaje2, setMensaje2] = useState('¡Hola! Me llamo Lucía. Puedo leer cualquier texto que escribas.');

  const [voz3, setVoz3] = useState('Danielle');
  const [mensaje3, setMensaje3] = useState('Hi! My name is Danielle. I will read any text you type here.');

  const [voz4, setVoz4] = useState('Mia');
  const [mensaje4, setMensaje4] = useState('¡Hola! Me llamo Mía. Voy a leer el texto que ingreses aquí.');

  const [voz5, setVoz5] = useState('Vitoria');
  const [mensaje5, setMensaje5] = useState('Olá, meu nome é Vitória. Eu posso ler qualquer texto que você digitar aqui.');

  const [showDownloadButton, setShowDownloadButton] = useState(false);
  const [showDownloadButton2, setShowDownloadButton2] = useState(false);
  const [showDownloadButton3, setShowDownloadButton3] = useState(false);
  const [showDownloadButton4, setShowDownloadButton4] = useState(false);
  const [showDownloadButton5, setShowDownloadButton5] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);


  const apiEndpoint =
    'https://xo8cblasg3.execute-api.us-east-1.amazonaws.com/produccion/codeflex';

  const submitHandlerEEUU = async () => {

    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Generando...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);


    setShowDownloadButton(false);
    setShowDownloadButton2(false);
    setShowDownloadButton3(false);
    setShowDownloadButton4(false);
    setShowDownloadButton5(false);
    if (mensaje.trim() === '' || voz.trim() === '') {
      alert('El campo de mensaje y voz no puede estar vacío.');
      return;
    }
    if (isPlaying) {
      stopAudio();
    }
    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          Text: mensaje,
          VoiceId: voz,
          LanguageCode: 'es-US',
          accion: 'activar',
        }),
      });
      if (response.ok) {
        const data = await response.json();
        const audioData = data.audioData;
        const audioBlob = new Blob(
          [Uint8Array.from(atob(audioData), (c) => c.charCodeAt(0))],
          { type: 'audio/mpeg' }
        );
        const audioUrl = URL.createObjectURL(audioBlob);
        document.body.removeChild(overlay);
        // Después de establecer el estado de audioBlob
        setAudioBlob(audioBlob);
        setShowDownloadButton(true);

        // Reproducir el audio
        const newAudioPlayer = new Audio(audioUrl);
        newAudioPlayer.play();
        newAudioPlayer.onended = function () {
          setIsPlaying(false);
          console.log('Reproducción de audio completada');
        };
        // Establecer el reproductor de audio en el estado
        setAudioPlayer(newAudioPlayer);
        setIsPlaying(true);
      } else {
        console.error('Error al llamar a la API');
      }
    } catch (error) {
      console.error('Error al realizar la solicitud:', error);
    }
  };


  const submitHandlerES = async () => {

    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Generando...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);

    setShowDownloadButton(false);
    setShowDownloadButton2(false);
    setShowDownloadButton3(false);
    setShowDownloadButton4(false);
    setShowDownloadButton5(false);
    if (mensaje2.trim() === '' || voz2.trim() === '') {
      alert('El campo de mensaje y voz no puede estar vacío.');
      return;
    }
    if (isPlaying) {
      stopAudio();
    }
    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          Text: mensaje2,
          VoiceId: voz2,
          LanguageCode: 'es-ES',
          accion: 'activar',
        }),
      });
      if (response.ok) {
        const data = await response.json();
        const audioData = data.audioData;
        const audioBlob = new Blob(
          [Uint8Array.from(atob(audioData), (c) => c.charCodeAt(0))],
          { type: 'audio/mpeg' }
        );
        const audioUrl = URL.createObjectURL(audioBlob);
        document.body.removeChild(overlay);
        setAudioBlob(audioBlob);
        setShowDownloadButton2(true);

        // Reproducir el audio
        const newAudioPlayer = new Audio(audioUrl);
        newAudioPlayer.play();
        newAudioPlayer.onended = function () {
          setIsPlaying(false);
          console.log('Reproducción de audio completada');
        };
        // Establecer el reproductor de audio en el estado
        setAudioPlayer(newAudioPlayer);
        setIsPlaying(true);
      } else {
        console.error('Error al llamar a la API');
      }
    } catch (error) {
      console.error('Error al realizar la solicitud:', error);
    }
  };



  const submitHandlerUU = async () => {

    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Generando...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);

    setShowDownloadButton(false);
    setShowDownloadButton2(false);
    setShowDownloadButton3(false);
    setShowDownloadButton4(false);
    setShowDownloadButton5(false);
    if (mensaje3.trim() === '' || voz3.trim() === '') {
      alert('El campo de mensaje y voz no puede estar vacío.');
      return;
    }
    if (isPlaying) {
      stopAudio();
    }
    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          Text: mensaje3,
          VoiceId: voz3,
          LanguageCode: 'en-US',
          accion: 'activar',
        }),
      });
      if (response.ok) {
        const data = await response.json();
        const audioData = data.audioData;
        const audioBlob = new Blob(
          [Uint8Array.from(atob(audioData), (c) => c.charCodeAt(0))],
          { type: 'audio/mpeg' }
        );
        const audioUrl = URL.createObjectURL(audioBlob);
        document.body.removeChild(overlay);
        setAudioBlob(audioBlob);
        setShowDownloadButton3(true);

        // Reproducir el audio
        const newAudioPlayer = new Audio(audioUrl);
        newAudioPlayer.play();
        newAudioPlayer.onended = function () {
          setIsPlaying(false);
          console.log('Reproducción de audio completada');
        };
        // Establecer el reproductor de audio en el estado
        setAudioPlayer(newAudioPlayer);
        setIsPlaying(true);
      } else {
        console.error('Error al llamar a la API');
      }
    } catch (error) {
      console.error('Error al realizar la solicitud:', error);
    }
  };


  const submitHandlerMX = async () => {

    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Generando...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);

    setShowDownloadButton(false);
    setShowDownloadButton2(false);
    setShowDownloadButton3(false);
    setShowDownloadButton4(false);
    setShowDownloadButton5(false);
    if (mensaje4.trim() === '' || voz4.trim() === '') {
      alert('El campo de mensaje y voz no puede estar vacío.');
      return;
    }
    if (isPlaying) {
      stopAudio();
    }
    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          Text: mensaje4,
          VoiceId: voz4,
          LanguageCode: 'es-MX',
          accion: 'activar',
        }),
      });
      if (response.ok) {
        const data = await response.json();
        const audioData = data.audioData;
        const audioBlob = new Blob(
          [Uint8Array.from(atob(audioData), (c) => c.charCodeAt(0))],
          { type: 'audio/mpeg' }
        );
        const audioUrl = URL.createObjectURL(audioBlob);
        document.body.removeChild(overlay);
        setAudioBlob(audioBlob);
        setShowDownloadButton4(true);

        // Reproducir el audio
        const newAudioPlayer = new Audio(audioUrl);
        newAudioPlayer.play();
        newAudioPlayer.onended = function () {
          setIsPlaying(false);
          console.log('Reproducción de audio completada');
        };
        // Establecer el reproductor de audio en el estado
        setAudioPlayer(newAudioPlayer);
        setIsPlaying(true);
      } else {
        console.error('Error al llamar a la API');
      }
    } catch (error) {
      console.error('Error al realizar la solicitud:', error);
    }
  };


  const submitHandlerBR = async () => {

    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.zIndex = '9999';
    const spinner = document.createElement('div');
    spinner.className = 'spinner-border text-primary';
    spinner.setAttribute('role', 'status');
    const srOnly = document.createElement('span');
    srOnly.className = 'visually-hidden';
    srOnly.textContent = '';
    const downloadingText = document.createElement('p');
    downloadingText.textContent = 'Generando...';
    downloadingText.style.marginTop = '10px';
    spinner.appendChild(srOnly);
    overlay.appendChild(spinner);
    overlay.appendChild(downloadingText);
    document.body.appendChild(overlay);

    setShowDownloadButton(false);
    setShowDownloadButton2(false);
    setShowDownloadButton3(false);
    setShowDownloadButton4(false);
    setShowDownloadButton5(false);
    if (mensaje5.trim() === '' || voz5.trim() === '') {
      alert('El campo de mensaje y voz no puede estar vacío.');
      return;
    }
    if (isPlaying) {
      stopAudio();
    }
    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          Text: mensaje5,
          VoiceId: voz5,
          LanguageCode: 'pt-BR',
          accion: 'activar',
        }),
      });
      if (response.ok) {
        const data = await response.json();
        const audioData = data.audioData;
        const audioBlob = new Blob(
          [Uint8Array.from(atob(audioData), (c) => c.charCodeAt(0))],
          { type: 'audio/mpeg' }
        );
        const audioUrl = URL.createObjectURL(audioBlob);
        document.body.removeChild(overlay);
        setAudioBlob(audioBlob);
        setShowDownloadButton5(true);

        // Reproducir el audio
        const newAudioPlayer = new Audio(audioUrl);
        newAudioPlayer.play();
        newAudioPlayer.onended = function () {
          setIsPlaying(false);
          console.log('Reproducción de audio completada');
        };
        // Establecer el reproductor de audio en el estado
        setAudioPlayer(newAudioPlayer);
        setIsPlaying(true);
      } else {
        console.error('Error al llamar a la API');
      }
    } catch (error) {
      console.error('Error al realizar la solicitud:', error);
    }
  };

  const stopAudio = () => {
    if (audioPlayer) {
      setShowDownloadButton(false);
      setShowDownloadButton2(false);
      setShowDownloadButton3(false);
      setShowDownloadButton4(false);
      setShowDownloadButton5(false);
      audioPlayer.pause();
      audioPlayer.currentTime = 0; 
      setIsPlaying(false);
    }
  };

  const handleVozChange = (e) => {
    const selectedVoz = e.target.value;
    setVoz(selectedVoz);

    // Actualizar el mensaje según la voz seleccionada
    if (selectedVoz === 'Lupe') {
      setMensaje('Hola! Mi nombre es Lupe. Puedo leer cualquier texto que introduzcas aquí.');
    } else if (selectedVoz === 'Pedro') {
      setMensaje('Hola! Mi nombre es Pedro. Puedo leer cualquier texto que introduzcas aquí.');
    }
  };


  const handleVozChange2 = (e) => {
    const selectedVoz = e.target.value;
    setVoz2(selectedVoz);

    // Actualizar el mensaje según la voz seleccionada
    if (selectedVoz === 'Lucia') {
      setMensaje2('¡Hola! Me llamo Lucía. Puedo leer cualquier texto que escribas.');
    } else if (selectedVoz === 'Sergio') {
      setMensaje2('¡Hola! Me llamo Sergio. Puedo leer cualquier texto que escribas.');
    }
  };


  const handleVozChange3 = (e) => {
    const selectedVoz = e.target.value;
    setVoz3(selectedVoz);

    // Actualizar el mensaje según la voz seleccionada
    if (selectedVoz === 'Danielle') {
      setMensaje3('Hi! My name is Danielle. I will read any text you type here.');
    } else if (selectedVoz === 'Gregory') {
      setMensaje3('Hi! My name is Gregory. I will read any text you type here.');
    }else if (selectedVoz === 'Ivy') {
      setMensaje3('Hi! My name is Ivy. I will read any text you type here.');
    }else if (selectedVoz === 'Kevin') {
      setMensaje3('Hello! My name is Kevin. I will read any text you type here.');
    }else if (selectedVoz === 'Stephen') {
      setMensaje3('Hi! My name is Stephen. I will read any text you type here.');
    }else if (selectedVoz === 'Ruth') {
      setMensaje3('Hi! My name is Ruth. I will read any text you type here.');
    }else if (selectedVoz === 'Joey') {
      setMensaje3('Hi! My name is Joey. I will read any text you type here.');
    }else if (selectedVoz === 'Salli') {
      setMensaje3('Hi! My name is Salli. I will read any text you type here.');
    }
  };


  const handleVozChange4 = (e) => {
    const selectedVoz = e.target.value;
    setVoz4(selectedVoz);

    // Actualizar el mensaje según la voz seleccionada
    if (selectedVoz === 'Mia') {
      setMensaje4('¡Hola! Me llamo Mía. Voy a leer el texto que ingreses aquí.');
    } else if (selectedVoz === 'Andres') {
      setMensaje4('¡Hola! Me llamo Andrés. Voy a leer el texto que ingreses aquí.');
    }
  };

  const handleVozChange5 = (e) => {
    const selectedVoz = e.target.value;
    setVoz5(selectedVoz);

    // Actualizar el mensaje según la voz seleccionada
    if (selectedVoz === 'Vitoria') {
      setMensaje5('Olá, meu nome é Vitória. Eu posso ler qualquer texto que você digitar aqui.');
    } else if (selectedVoz === 'Camila') {
      setMensaje5('Olá, meu nome é Camila. Eu posso ler qualquer texto que você digitar aqui.');
    } else if (selectedVoz === 'Thiago') {
      setMensaje5('Olá, meu nome é Thiago. Eu posso ler qualquer texto que você digitar aqui.');
    }
  };
  
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mt={4}>

      {base ? 
      <>
      <CCol xs={12}>
        <p style={{color:"tomato" , fontSize:"18px"}}>TokenSub: <spam style={{color:"black"}}>{sub}</spam></p>
        <CCard className="mb-4 ccard-custom-style" style={{ borderRadius: '6px' }}>
          <CCardHeader>
            <strong>Español (EE. UU.)</strong> <small>/Text To Speech (Modo Premium)</small>
          </CCardHeader>
          <CCardBody>
            <CCard>
              <CCardBody style={{ borderRadius: '6px' }}>
                <div className="row g-3">
                  <CCol md={4}>
                    <CFormSelect
                      size="sm"
                      id="inputState"
                      label="Voz"
                      value={voz}
                      onChange={handleVozChange}
                      required
                    >
                      <option value="Pedro">Pedro, Hombre (EE. UU.)</option>
                      <option value="Lupe">Lupe, Mujer (EE. UU.)</option>
                    </CFormSelect>
                  </CCol>

                  <CCol md={6}>
                    <CFormTextarea
                      maxLength="3600"
                      size="sm"
                      id="exampleFormControlTextarea1"
                      label="Texto de entrada"
                      rows={3}
                      value={mensaje}
                      onChange={(e) => setMensaje(e.target.value)}
                      required
                    ></CFormTextarea>
                  </CCol>

                  <CCol xs={12}>
                    <div className="d-flex">
                      <CButton onClick={submitHandlerEEUU}>Escuchar</CButton> &nbsp;&nbsp;&nbsp;
                      <CButton color="warning" onClick={stopAudio}>
                        Detener
                      </CButton>&nbsp;&nbsp;&nbsp;
                      {showDownloadButton && (
                        <a
                          href={URL.createObjectURL(audioBlob)}
                          download="audio.mp3"
                        >
                          <CButton color="success">Descargar</CButton>
                        </a>
                      )}
                    </div>
                  </CCol>
                </div>
              </CCardBody>
            </CCard>
          </CCardBody>
        </CCard>
      </CCol>

      <br/>
      <CCol xs={12}>
        <CCard className="mb-4 ccard-custom-style" style={{ borderRadius: '6px' }}>
          <CCardHeader>
            <strong>Español (México)</strong> <small>/Text To Speech (Modo Premium)</small>
          </CCardHeader>
          <CCardBody>
            <CCard>
              <CCardBody style={{ borderRadius: '6px' }}>
                <div className="row g-3">
                  <CCol md={4}>
                    <CFormSelect
                      size="sm"
                      id="inputState"
                      label="Voz"
                      value={voz4}
                      onChange={handleVozChange4}
                      required
                    >
                      <option value="Andres">Andrés, Hombre (México)</option>
                      <option value="Mia">Mia, Mujer (México)</option>
                    </CFormSelect>
                  </CCol>

                  <CCol md={6}>
                    <CFormTextarea
                      maxLength="3600"
                      size="sm"
                      id="exampleFormControlTextarea1"
                      label="Texto de entrada"
                      rows={3}
                      value={mensaje4}
                      onChange={(e) => setMensaje4(e.target.value)}
                      required
                    ></CFormTextarea>
                  </CCol>

                  <CCol xs={12}>
                    <div className="d-flex">
                      <CButton onClick={submitHandlerMX}>Escuchar</CButton> &nbsp;&nbsp;&nbsp;
                      <CButton color="warning" onClick={stopAudio}>
                        Detener
                      </CButton>&nbsp;&nbsp;&nbsp;
                      {showDownloadButton4 && (
                        <a
                          href={URL.createObjectURL(audioBlob)}
                          download="audio.mp3"
                        >
                          <CButton color="success">Descargar</CButton>
                        </a>
                      )}
                    </div>
                  </CCol>
                </div>
              </CCardBody>
            </CCard>
          </CCardBody>
        </CCard>
      </CCol>

      <br/>
      <CCol xs={12}>
        <CCard className="mb-4 ccard-custom-style" style={{ borderRadius: '6px' }}>
          <CCardHeader>
            <strong>Español (España)</strong> <small>/Text To Speech (Modo Premium)</small>
          </CCardHeader>
          <CCardBody>
            <CCard>
              <CCardBody style={{ borderRadius: '6px' }}>
                <div className="row g-3">
                  <CCol md={4}>
                    <CFormSelect
                      size="sm"
                      id="inputState"
                      label="Voz"
                      value={voz2}
                      onChange={handleVozChange2}
                      required
                    >
                      <option value="Sergio">Sergio, Hombre (España)</option>
                      <option value="Lucia">Lucia, Mujer (España)</option>
                    </CFormSelect>
                  </CCol>

                  <CCol md={6}>
                    <CFormTextarea
                      maxLength="3600"
                      size="sm"
                      id="exampleFormControlTextarea1"
                      label="Texto de entrada"
                      rows={3}
                      value={mensaje2}
                      onChange={(e) => setMensaje2(e.target.value)}
                      required
                    ></CFormTextarea>
                  </CCol>

                  <CCol xs={12}>
                    <div className="d-flex">
                      <CButton onClick={submitHandlerES}>Escuchar</CButton> &nbsp;&nbsp;&nbsp;
                      <CButton color="warning" onClick={stopAudio}>
                        Detener
                      </CButton>&nbsp;&nbsp;&nbsp;
                      {showDownloadButton2 && (
                        <a
                          href={URL.createObjectURL(audioBlob)}
                          download="audio.mp3"
                        >
                          <CButton color="success">Descargar</CButton>
                        </a>
                      )}
                    </div>
                  </CCol>
                </div>
              </CCardBody>
            </CCard>
          </CCardBody>
        </CCard>
      </CCol>
      <br/>

      <CCol xs={12}>
        <CCard className="mb-4 ccard-custom-style" style={{ borderRadius: '6px' }}>
          <CCardHeader>
            <strong>Inglés (EE. UU.)</strong> <small>/Text To Speech (Modo Premium)</small>
          </CCardHeader>
          <CCardBody>
            <CCard>
              <CCardBody style={{ borderRadius: '6px' }}>
                <div className="row g-3">
                  <CCol md={4}>
                    <CFormSelect
                      size="sm"
                      id="inputState"
                      label="Voz"
                      value={voz3}
                      onChange={handleVozChange3}
                      required
                    >
                      <option value="Kevin">Kevin, Hombre (Inglés)</option>
                      <option value="Gregory">Gregory, Hombre (Inglés)</option>
                      <option value="Stephen">Stephen, Hombre (Inglés)</option>
                      <option value="Joey">Joey, Hombre (Inglés)</option>
                      <option value="Danielle">Danielle, Mujer (Inglés)</option>
                      <option value="Ivy">Ivy, Mujer (Inglés)</option>
                      <option value="Ruth">Ruth, Mujer (Inglés)</option>
                      <option value="Salli">Salli, Mujer (Inglés)</option>
                    </CFormSelect>
                  </CCol>

                  <CCol md={6}>
                    <CFormTextarea
                      maxLength="3600"
                      size="sm"
                      id="exampleFormControlTextarea1"
                      label="Texto de entrada"
                      rows={3}
                      value={mensaje3}
                      onChange={(e) => setMensaje3(e.target.value)}
                      required
                    ></CFormTextarea>
                  </CCol>

                  <CCol xs={12}>
                    <div className="d-flex">
                      <CButton onClick={submitHandlerUU}>Escuchar</CButton> &nbsp;&nbsp;&nbsp;
                      <CButton color="warning" onClick={stopAudio}>
                        Detener
                      </CButton>&nbsp;&nbsp;&nbsp;
                      {showDownloadButton3 && (
                        <a
                          href={URL.createObjectURL(audioBlob)}
                          download="audio.mp3"
                        >
                          <CButton color="success">Descargar</CButton>
                        </a>
                      )}
                    </div>
                  </CCol>
                </div>
              </CCardBody>
            </CCard>
          </CCardBody>
        </CCard>
      </CCol>

      <br/>

      <CCol xs={12}>
        <CCard className="mb-4 ccard-custom-style" style={{ borderRadius: '6px' }}>
          <CCardHeader>
            <strong>Portugués (Brasil)</strong> <small>/Text To Speech (Modo Premium)</small>
          </CCardHeader>
          <CCardBody>
            <CCard>
              <CCardBody style={{ borderRadius: '6px' }}>
                <div className="row g-3">
                  <CCol md={4}>
                    <CFormSelect
                      size="sm"
                      id="inputState"
                      label="Voz"
                      value={voz5}
                      onChange={handleVozChange5}
                      required
                    >
                      <option value="Thiago">Thiago, Hombre (Brasil)</option>
                      <option value="Vitoria">Vitória, Mujer (Brasil)</option>
                      <option value="Camila">Camila, Mujer (Brasil)</option>

                    </CFormSelect>
                  </CCol>

                  <CCol md={6}>
                    <CFormTextarea
                      maxLength="3600"
                      size="sm"
                      id="exampleFormControlTextarea1"
                      label="Texto de entrada"
                      rows={3}
                      value={mensaje5}
                      onChange={(e) => setMensaje5(e.target.value)}
                      required
                    ></CFormTextarea>
                  </CCol>

                  <CCol xs={12}>
                    <div className="d-flex">
                      <CButton onClick={submitHandlerBR}>Escuchar</CButton> &nbsp;&nbsp;&nbsp;
                      <CButton color="warning" onClick={stopAudio}>
                        Detener
                      </CButton>&nbsp;&nbsp;&nbsp;
                      {showDownloadButton5 && (
                        <a
                          href={URL.createObjectURL(audioBlob)}
                          download="audio.mp3"
                        >
                          <CButton color="success">Descargar</CButton>
                        </a>
                      )}
                    </div>
                  </CCol>
                </div>
              </CCardBody>
            </CCard>
          </CCardBody>
        </CCard>
      </CCol> 
       </>
        :
        <CCol xs={12}>
          <CCard className="mb-4 ccard-custom-style">
            <CCardHeader>
              <strong className="text-primary">
                Este servicio solamente se encuentra en modo premium
              </strong>
            </CCardHeader>
            <CCardBody>
              <p>
                El usuario {email} no se encuentra en dicho modo. Para acceder a este servicio, se recomienda activar su membresía.
              </p>
            </CCardBody>
          </CCard>
        </CCol>
        }  

      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Billing;
